(function() {

    a3_pilot_reports.directive('trainingMenu', trainingMenu);

    /**
     * @memberof PilotReports
     * @ngdoc directive
     * @name ground Course List
     * @restrict E
     * @description
     *   Initialize navigation menu panel with with status indicators
     * @example
     *   Usage:
     *   <training-menu type="ground, crewroute, flight" id="groundDutyId, flightId" ></training-menu>
     * @ngInject
     */

    function trainingMenu(CourseFactory, GroundDutyFactory, FlightFactory, CrewRouteFactory, $location, TrainingSessionFactory, FlightSessionFactory, $filter, $routeParams) {
        function link($scope, attrs) {
            $scope.gotoCourse = gotoCourse;
            $scope.hasPendingTraining = false;
            $scope.hasUnsetTraining = false;

            var groundSessions = [];
            var flightSessions = [];
            TrainingSessionFactory.getAll(function(savedGroundSessions) {
                FlightSessionFactory.getAll(function(savedFlightSessions) {
                    groundSessions = savedGroundSessions;
                    flightSessions = savedFlightSessions;

                    $scope.courses = [];
                    var duty = null;
                    var dutyCourses = [];

                    if ($scope.type == 'ground') {
                        duty = GroundDutyFactory.getGroundDutyFromStorage($scope.id);
                        $scope.duty = duty;

                        // if (duty && duty.RelatedGroundDuties) {
                        //     dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);
                        //     if (dutyCourses) {

                        //          // Retrieve saved courses by combining CourseId and PhaseId, representing the unique identifiers for each course phase.
                        //         // This ensures that courses are fetched with their associated phases.
                        //         CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId+"_"+course.PhaseId }), function(savedCourses) {
                        //             manageGroundCourseStatuses(duty, dutyCourses, savedCourses);

                        //             //Overall panel color
                        //             // "Draft" courses indicate an orange border, "Pending" or "Outdated" courses a blue border, and all others green.
                        //             if(savedCourses.some(x => x.Status == "Draft")){
                        //                 $scope.PanelClass="border-bottom-orange";
                        //             }
                        //             else if(savedCourses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
                        //                 $scope.PanelClass="border-bottom-blue";
                        //             }
                        //             else{
                        //                 $scope.PanelClass="border-bottom-green";
                        //             }

                        //             $scope.courses.concat(savedCourses);
                        //         });
                        //         // Fetch saved courses only by CourseId (without PhaseId), which may be used for backward compatibility.
                        //         CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId }), function(savedCourses) {
                        //             manageGroundCourseStatuses(duty, dutyCourses, savedCourses);

                        //             //Overall panel color
                        //             if(savedCourses.some(x => x.Status == "Draft")){
                        //                 $scope.PanelClass="border-bottom-orange";
                        //             }
                        //             else if(savedCourses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
                        //                 $scope.PanelClass="border-bottom-blue";
                        //             }
                        //             else{
                        //                 $scope.PanelClass="border-bottom-green";
                        //             }

                        //             $scope.courses.concat(savedCourses);
                        //         });
                        //     }
                        // }



                           if (duty && duty.RelatedGroundDuties) {
                        dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);
                        
                        if (dutyCourses && dutyCourses.length > 0) {
                            var courseIdsWithPhase = dutyCourses
                                .filter(course => course.PhaseId !== null && course.PhaseId !== undefined) // Ensure PhaseId exists
                                .map(course => `${course.CourseId}_${course.PhaseId}`);
                    
                            var courseIdsWithoutPhase = dutyCourses.map(course => course.CourseId);
                    
                            // Fetch saved courses by CourseId & PhaseId
                            CourseFactory.getCoursesFromStorageByIds(courseIdsWithPhase, function(savedCoursesWithPhase) {
                                savedCoursesWithPhase = savedCoursesWithPhase || []; 
                            
                                //  Fetch saved courses only by CourseId **if there are missing phase-based courses**
                                if (savedCoursesWithPhase.length === 0) {
                                    CourseFactory.getCoursesFromStorageByIds(courseIdsWithoutPhase, function(savedCoursesWithoutPhase) {
                                        savedCoursesWithoutPhase = savedCoursesWithoutPhase || [];
                            
                                        var combinedCourses = [...savedCoursesWithPhase, ...savedCoursesWithoutPhase]
                                            .filter((value, index, self) => index === self.findIndex(c => c.Id === value.Id));
                            
                                        manageGroundCourseStatuses(duty, dutyCourses, combinedCourses);
                            
                                        // Assign overall panel color based on course statuses
                                        if (combinedCourses.some(x => x.Status === "Draft")) {
                                            $scope.PanelClass = "border-bottom-orange";
                                        } else if (combinedCourses.some(x => x.Status === "Pending" || x.Status === "Outdated")) {
                                            $scope.PanelClass = "border-bottom-blue";
                                        } else {
                                            $scope.PanelClass = "border-bottom-green";
                                        }
                            
                                        $scope.courses = combinedCourses;
                                    });
                                } else {
                                    //  If phase-based courses exist, **use only them** and skip the second fetch
                                    manageGroundCourseStatuses(duty, dutyCourses, savedCoursesWithPhase);
                                    
                                    // Assign panel color
                                    if (savedCoursesWithPhase.some(x => x.Status === "Draft")) {
                                        $scope.PanelClass = "border-bottom-orange";
                                    } else if (savedCoursesWithPhase.some(x => x.Status === "Pending" || x.Status === "Outdated")) {
                                        $scope.PanelClass = "border-bottom-blue";
                                    } else {
                                        $scope.PanelClass = "border-bottom-green";
                                    }
                            
                                    $scope.courses = savedCoursesWithPhase;
                                }
                            });
                            
                        }
                    } 
                    }

                 
                    else if($scope.type == 'crewroute' || $scope.type == 'flight'){
                        if($scope.type == 'crewroute'){
                            duty = CrewRouteFactory.getCrewRouteFromStorage($scope.dutyNo, $scope.dutyDay);
                        }
                        else{
                            duty = FlightFactory.getFlightFromTotalFlights($scope.id);
                        }
                        if (duty && duty.Courses) {
                            dutyCourses = duty.Courses;
                            
                            // Retrieve courses using CourseId and optionally PhaseId (if present) for composite matching
                            const courseIds = dutyCourses.map(course => {
                                return course.PhaseId ? `${course.CourseId}_${course.PhaseId}` : course.CourseId;
                            });
                       
                            CourseFactory.getCoursesFromStorageByIds(courseIds, function(savedCourses) {
  
                                dutyCourses.forEach(function(dutyCourse) {
                                    // Determine the saved course by matching on both CourseId and PhaseId, if PhaseId exists
                                    var savedCourse = savedCourses.find(x => 
                                       x.Id === (dutyCourse.PhaseId ? `${dutyCourse.CourseId}_${dutyCourse.PhaseId}` : dutyCourse.CourseId)
                                    );
                                    
                                    if (savedCourse) {
                                        // Build the course object with available details, handling cases without PhaseId
                                        var course = {
                                            Id: savedCourse.Id,
                                            Title: savedCourse.Title,
                                            Day: new moment(dutyCourse.Date)
                                        };
                        
                                        // Include Phase details if they exist
                                        if (savedCourse.PhaseId) {
                                            course.PhaseId = savedCourse.PhaseId;
                                            course.PhaseTitle = savedCourse.PhaseTitle || 
                                            savedCourse.CrewCoursePhases.find(x => x.PhaseId === savedCourse.PhaseId)?.Title;
                                        }
                                        manageFlightCourseStatus(course, dutyCourse); // Update course status
                                        $scope.courses.push(course); // Add to courses list
                                    }
                                });
                        
                                // Format date properties and detect multi-day courses
                                $scope.courses.forEach(function(course) {
                                    course.FullDate = course.Day.format("YYYY-MM-DD");
                                    course.Day = course.Day.format("DD/MM");
                        
                                    // Check for multi-day courses, grouping by Id and PhaseId if PhaseId exists
                                    if ($scope.courses.filter(x => x.Id == course.Id && (!x.PhaseId || x.PhaseId == course.PhaseId)).length > 1) {
                                        course.IsMultiday = true;
                                    }
                                });
                        
                                // Set overall panel color based on course statuses
                                setPanelClassBasedOnStatus($scope.courses);
                            });
                        }
                    }                 
                });
            });

            // Function to determine and set panel color class based on course statuses
            function setPanelClassBasedOnStatus(courses) {
                if (courses.some(x => x.Status == "Draft")) {
                    $scope.PanelClass = "border-bottom-orange";
                } else if (courses.some(x => x.Status == "Pending" || x.Status == "Outdated")) {
                    $scope.PanelClass = "border-bottom-blue";
                } else {
                    $scope.PanelClass = "border-bottom-green";
                }
            }
            function manageFlightCourseStatus(course, crewRouteCourse){
                var now=moment.utc();
                var flights = FlightFactory.getFlightsFromStorage().filter(x => crewRouteCourse.TrainingFlightIds.includes(x.FlightId));
                flights = $filter('orderBy')(flights, 'ScheduledArrival');
                var dutyEnd = flights[flights.length-1].ScheduledArrival;

                var dutyDate =  new moment(crewRouteCourse.Date).format("YYYY-MM-DD");

                var status="";
                if(crewRouteCourse.Status == "Pending"){

                    //Pending
                    course.Status = "Pending";
                    course.StatusClass = "text-blue";
                        course.StatusDesc = "pending";
                    
                    //Outdated
                    dutyEnd = moment.utc(dutyEnd);
                    var duration = moment.duration(now.diff(dutyEnd)).asHours();
                    if(duration>1){
                        course.Status = "Outdated";
                    }

                    //Draft
					if(flightSessions && flightSessions.length){
                        if (crewRouteCourse.PhaseId){
                            flightSessions.forEach(session => {
                                // Parse the numeric part of courseId before the underscore
                                if (typeof session.courseId === 'string' && session.courseId.split('_').length > 1) {
                                    session.courseId = parseInt(session.courseId.split('_')[0], 10);
                                } else {
                                    // Handle cases where courseId doesn't have an underscore
                                    session.courseId = parseInt(session.courseId, 10);
                                }
                            });
                        }

						var existingSession = flightSessions.find(s => s.courseId == crewRouteCourse.CourseId && s.day == dutyDate && s.dutyDay == $scope.dutyDay && s.dutyNo == $scope.dutyNo);
						if(existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length){
							//a training session with trainees exists
                            course.Status = "Draft"
                            course.StatusClass = "text-orange";
                            course.StatusDesc = "draft";
						}
					}
                }else if(crewRouteCourse.Status == "Completed"){
                    //Completed
                    course.Status = "Completed";
                    course.StatusClass = "text-green";
                    course.StatusDesc = "synced";
                }

                return status;
            }

            function manageGroundCourseStatuses(duty, dutyCourses, courses) {
                var now = moment.utc();
                courses.forEach(function(course) {
                        if (typeof  course.Id === 'string' &&  course.Id.split('_').length > 1) {
                        course.Id = parseInt(course.Id.split('_')[0], 10);
                    } else {
                        // Handle cases where courseId doesn't have an underscore
                        course.Id = parseInt(course.Id, 10);
                    }
                    var dutyCourse = dutyCourses.find(x => x.CourseId == course.Id);
                    course.Status = dutyCourse.Status;

                    /*Statuses
                    	Completed : session has been sent
                    	Outdated  :	session submission is overdue
                    	Draft	  : session completion has started but not submitted
                    	Pending   : session submission not yet due
                    */

                    if (course.Status == "Pending") {
                        course.StatusClass = "text-blue";
                        course.StatusDesc = "pending";

                        //Outdated
                        var dutyEnd = moment.utc(duty.DutyEnd);
                        var duration = moment.duration(now.diff(dutyEnd)).asHours();
                        if (duration > 1) {
                            course.Status = "Outdated"
                        }

                        //Draft
                        // if (groundSessions && groundSessions.length) {
                        //     var existingSession = groundSessions.find(s => s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id);
                        //     if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                        //         //a training session with trainees exists
                        //         course.Status = "Draft"
                        //         course.StatusClass = "text-orange";
                        //         course.StatusDesc = "draft";
                        //     }
                        // }
                        if (groundSessions && groundSessions.length) {
                            if (dutyCourse.PhaseId) {
                                groundSessions.forEach(session => {
                                    // Ensure courseId is parsed correctly
                                    if (typeof session.courseId === 'string' && session.courseId.split('_').length > 1) {
                                        session.courseId = parseInt(session.courseId.split('_')[0], 10);
                                    } else {
                                        session.courseId = parseInt(session.courseId, 10);
                                    }
                                });
                            }
            
                            var existingSession = groundSessions.find(s => s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id);
                            if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                                course.Status = "Draft";
                                course.StatusClass = "text-orange";
                                course.StatusDesc = "draft";
                            }
                        }    
                     
                    } else if (course.Status == "Completed") {
                        //Completed
                        course.Status = "Completed";
                        course.StatusClass = "text-green";
                        course.StatusDesc = "synced";
                    }
                });             
            }

            /**
             * Redirect to Course Session
             */
            // function gotoCourse(course) {
            //     if($scope.type=="ground"){
            //         $location.path('/groundcourse/' + course.Id + '/' + $scope.duty.Id + "/" + $scope.duty.DutyDateS);
            //     }
            //     else if($scope.type=="crewroute"){
            //         $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
            //     }
            //     else if($scope.type=="flight"){
            //         $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId) + '/' + course.PhaseId);
            //     }
            // }         
            
            function gotoCourse(course) { 
                if ($scope.type === "ground") {
                    // if (course.PhaseId != null && course.PhaseId != undefined) {
                    //     course.Id = `${course.CourseId}_${course.PhaseId}`; // Combine CourseId & PhaseId
                    // } 

                    if (course.PhaseId != null && course.PhaseId != undefined) {
                        course.Id = `${course.CourseId ?? course.Id}_${course.PhaseId}`;
                    } else {
                        course.Id = course.CourseId ?? course.Id;
                    }                  
                
                    var path = '/groundcourse/' + course.Id + '/' + $scope.duty.Id + '/' + $scope.duty.DutyDateS;
                       // Append phaseId if it exists
                       if (course.PhaseId) {
                        path += '/' + course.PhaseId;
                    }

                    $location.path(path);
                } 
                else if ($scope.type === "crewroute") {
                    $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
                } 
                else if ($scope.type === "flight") {
                    var path = '/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId);
            
                    // Append phaseId if it exists
                    if (course.PhaseId) {
                        path += '/' + course.PhaseId;
                    }
            
                    $location.path(path);
                }
            }    
        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/training-menu.tpl.html",
            scope: {
                type: '@',
                id: '=',
                dutyNo: '=',
                dutyDay: '='
            },
            terminal: true,
            link: link
        }
    }
})();


